<template>
	<TeamingDropDown
		class="meridiem-drop-down"
		:options="options"
	/>
</template>

<script>
import {
	default as TeamingDropDown,
	makeOption
} from "./TeamingDropDown.vue";

const options = [
	makeOption( {
		text: "AM",
		value: "am",
	} ),
	makeOption( {
		text: "PM",
		value: "pm",
	} ),
];

export default {
	name: "MeridiemDropDown",
	components: {
		TeamingDropDown,
	},
	computed: {
		options() {
			return options;
		},
	},
};
</script>

<style lang="scss" scoped></style>
